"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPreOrderItemDetailsComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const constants = require("../../../util/constants");
class CSPreOrderItemDetailsComponent {
    constructor(modalService, router) {
        this.modalService = modalService;
        this.router = router;
        this.enterSSNEmitter = new core_1.EventEmitter();
    }
    editDevice() {
        if (this.isLoggedInUser && this.preOrderData) {
            this.router.navigate(['/preorder/' + this.preOrderData.preorderId]);
        }
        else {
            this.modelRef = this.modalService.open(this.modalDevice, { centered: true });
        }
    }
    enterSSN() {
        this.enterSSNEmitter.emit(true);
    }
    calculateDPPPrice(preorderItem) {
        let devicePrice = Number(preorderItem.estimatedPrice);
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.mandatoryDownPayment)) {
            devicePrice = devicePrice - preorderItem.mandatoryDownPayment;
        }
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.voluntaryDownPayment)) {
            devicePrice = devicePrice - preorderItem.voluntaryDownPayment;
        }
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.discountsApplied)) {
            devicePrice = devicePrice - preorderItem.discountsApplied;
        }
        devicePrice = devicePrice / Number(preorderItem.dppTermLength);
        return devicePrice > 0 ? devicePrice : 0;
    }
    /**
     * @returns redirects the user to sign in page
     */
    goToSignIn() {
        location.href = constants.loginUrl;
        this.modelRef.close();
    }
}
exports.CSPreOrderItemDetailsComponent = CSPreOrderItemDetailsComponent;
//# sourceMappingURL=preorder-item-details.component.js.map